// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__zGv0H","errorLogs":"EditorFooter_errorLogs__D6wzA"};